import { RP } from '@api/types/resource-plan'
import apiClient from './apiClient/camera'
import { ApiBase } from './types'




export const CameraRpApi = {
  getDispatchStatus,
  getDispatch,
  searchDpByPerson,
  searchDispatch,
  updateDispatch,
  getPersonDispatch,
  addPersonDispatchRest,
  updatePersonDispatchRest,
  cancelPersonDispatchRest,
  checkRestTimeClash,
  getDpListByPerson,
  accept

}
async function getDispatchStatus(params: RP.ApiTypes.GetDpReq) {
  const res = await apiClient.request({
    url: '/rp/dispatch/status',
    method: 'post',
    data: params

  })
  return res.data
}
async function getDispatch(params:RP.ApiTypes.GetDpReq):Promise<ApiBase<RP.Domains.DispatchExt>>{
  const res = await apiClient.request({
    url: '/rp/dispatch/detail',
    method: 'post',
    data:params
  })
  return res.data
}
async function searchDpByPerson(params: Pick<RP.ApiTypes.SearchDisPatchReq, 'companyId' | 'faceEntityId' | 'fromDate' | 'status' | 'extended' | 'accepted'>): Promise<ApiBase<RP.Domains.DispatchExt[]>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/search/by/person',
    method: 'post',
    data: params

  })
  return res.data
}

async function getPersonDispatch(params: RP.ApiTypes.PersonDispatchRestReq): Promise<ApiBase<RP.Domains.DispatchExt[]>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/person/info',
    method: 'post',
    data: params

  })
  return res.data
}

async function addPersonDispatchRest(params: RP.ApiTypes.PersonDispatchRestReq): Promise<ApiBase<RP.Domains.DispatchExt[]>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/person/rest/add',
    method: 'post',
    data: params

  })
  return res.data
}

async function updatePersonDispatchRest(params: RP.ApiTypes.PersonDispatchRestReq): Promise<ApiBase<RP.Domains.DispatchExt[]>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/person/rest/update',
    method: 'post',
    data: params

  })
  return res.data
}

async function cancelPersonDispatchRest(params: RP.ApiTypes.PersonDispatchRestReq): Promise<ApiBase<RP.Domains.DispatchExt[]>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/person/rest/cancel',
    method: 'post',
    data: params

  })
  return res.data
}

async function searchDispatch(params: RP.ApiTypes.SearchDisPatchReq): Promise<ApiBase<RP.Domains.Dispatch[]>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/search',
    method: 'post',
    data: params

  })
  return res.data
}


async function updateDispatch(params: RP.ApiTypes.UpdateDispatchReq): Promise<ApiBase<RP.Domains.Dispatch>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/update',
    method: 'post',
    data: params

  })
  return res.data
}

async function checkRestTimeClash(params: RP.ApiTypes.CheckRestTimeClashReq): Promise<ApiBase<RP.Domains.Dispatch>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/validate/rest/time',
    method: 'post',
    data: params

  })
  return res.data
}

async function getDpListByPerson(params: RP.ApiTypes.PersonDispatchListReq): Promise<ApiBase<RP.Domains.Dispatch>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/list/by/person',
    method: 'post',
    data: params

  })
  return res.data
}

async function accept(params: Pick<RP.ApiTypes.UpdateDispatchReq, 'companyId' | '_id' | 'faceEntityId' | 'accepted'>): Promise<ApiBase<RP.Domains.Dispatch>> {
  const res = await apiClient.request({
    url: '/rp/dispatch/accept',
    method: 'post',
    data: params

  })
  return res.data
}



